// Shared App 100 appearance. Both palettes are defined in the repository guide.
(function () {
  'use strict';
  if (window.lxpAppearance) { return; }
  var key = 'lxp-app-theme';
  var mode = 'light';
  try {
    mode = localStorage.getItem(key) || localStorage.getItem('lxp-company-settings-theme') || mode;
  } catch (ignore) { /* Appearance still works when storage is disabled. */ }
  if (mode !== 'dark') { mode = 'light'; }
  function apply(value, save) {
    mode = value === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-lp-theme', mode);
    if (document.body) { document.body.setAttribute('data-lp-theme', mode); }
    if (save) {
      try { localStorage.setItem(key, mode); } catch (ignore) { /* Optional persistence. */ }
    }
    var button = document.getElementById('lp-app-appearance');
    if (button) {
      var hr = /^hr/i.test(document.documentElement.lang);
      var label = hr ? (mode === 'dark' ? 'Uključi svijetli način' : 'Uključi tamni način')
        : (mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      button.title = label;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', String(mode === 'dark'));
      button.firstElementChild.className = 't-Icon far ' + (mode === 'dark' ? 'fawe-sun' : 'fawe-moon');
    }
    document.dispatchEvent(new CustomEvent('lxp:appearance', {detail:mode}));
    // Keep open APEX modal pages in the same appearance immediately.
    document.querySelectorAll('iframe').forEach(function (frame) {
      try {
        if (frame.contentWindow.lxpAppearance) { frame.contentWindow.lxpAppearance.set(mode, false); }
      } catch (ignore) { /* Only same-origin APEX dialogs can be themed. */ }
    });
  }
  window.lxpAppearance = {get:function () { return mode; }, set:apply};
  apply(mode, false);
  function ready() {
    // Appearance controls belong inside the app, never on the public login page.
    if (document.body.matches('.t-PageBody--login, .t-PageTemplate--login') || document.querySelector('.lxpLoginHdr')) {
      return;
    }
    var header = document.querySelector('#t_Header .t-Header-navBar');
    if (header && !document.getElementById('lp-app-appearance')) {
      var button = document.createElement('button');
      button.id = 'lp-app-appearance';
      button.type = 'button';
      button.className = 't-Button t-Button--navBar t-Button--noLabel lp-app-appearance';
      var icon = document.createElement('span');
      icon.setAttribute('aria-hidden','true');
      button.appendChild(icon);
      button.addEventListener('click', function () { apply(mode === 'dark' ? 'light' : 'dark', true); });
      header.prepend(button);
    }
    apply(mode, false);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', ready); }
  else { ready(); }
  window.addEventListener('storage', function (event) {
    if (event.key === key) { apply(event.newValue, false); }
  });
})();

